import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// If you are scrolled down the page on the catalog, and you navigate to a program,
// you will be scrolled down the same amount on the program details page, likely
// missing the campus header photo, the start app button, etc
// This is to reset the scroll position to the top every time regardless of where your
// scroll position was on the previous page
// see https://reactrouter.com/web/guides/scroll-restoration
export const ScrollToTop: React.FC = () => {
	const { pathname } = useLocation();

	useEffect(() => {
		window.scrollTo(0, 0);
	}, [pathname]);

	return null;
};
